module.exports = __webpack_public_path__ + "img/Alexandre-Lenoir-Slider.e04df360.jpg";